import * as React from "react";
import {Card} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {GoogleIcon} from "../GoogleIcon";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import styles from "./css/login.module.scss";

type LoginProps = {
    loginEvent: () => void;
};

export const LoginComponent: React.SFC<LoginProps> = (props: LoginProps) => {
    return (
        <div className={styles.wrap}>
            <Card className={styles.card}>
                <AccountCircleIcon className={styles.userIcon} />
                <div className={styles.loginMessage}>Login</div>
                <Button
                    variant="outlined"
                    startIcon={<GoogleIcon />}
                    className={styles.googleButton}
                    onClick={() => props.loginEvent()}
                >
                    Google
                </Button>
            </Card>
        </div>
    );
};
